import { useNetwork } from '@tribeplatform/react-sdk/hooks'

export const useCustomFields = () => {
  const {
    data: {
      memberFields: { fields: memberFields },
    },
  } = useNetwork()

  return { memberFields }
}
